/**文献对比分析表格工具栏 */
<template>
  <div class="comparison-action-bar">
    <div class="table-bar-left">
      <div
        :class="['literature-review', 'option-tab']"
        @click="handleToggleComparisonPopper"
      >
        <ComparePopperCard
          ref="comparePopperCardRef"
          v-model:visible="comparePopperVisible"
          :comparisonItems="comparisonItemsList"
          :id="comparisonUid"
          @update="handleUpdateLsit"
          @loading="handleUpdateLoadingStatus"
        ></ComparePopperCard>
      </div>
      <div
        :class="['add-literature', 'option-tab']"
        @click="handleOpenSelectLiteratureDLG"
      >
        <i class="iconfont icon-zengjiatianjiajiahao"></i>
        添加文献
      </div>
      <div
        :class="['remove-literature', 'option-tab']"
        @click="handleClickRemove"
      >
        <i class="iconfont icon-shanchu"></i>
        删除文献
      </div>
      <div
        :class="['setting', 'option-tab']"
        @click="handleToggleSettingPopper"
      >
        <SettingPopperCard
          ref="settingPopperCardRef"
          v-model:visible="settingPopperCardVisible"
          @close="handleCloseSettingPopper"
        />
      </div>
    </div>
    <div class="table-bar-right">
      <!-- <el-tooltip content="导出" placement="top" effect="dark">
        <div class="option-icon export">
          <i class="iconfont icon-daochu1" @click="handleClickExport"></i>
        </div>
      </el-tooltip> -->
    </div>
  </div>
  <DialogSelectLiterature
    ref="dialogSelectLiteratureRef"
    @select="handleAddLiterature"
  />
</template>

<script setup>
import { ref, defineEmits, defineExpose, defineProps, watch } from "vue";
import { httpPost } from "@/api/httpService.js";
import DialogSelectLiterature from "@/components/literature/DialogSelectLiterature.vue";
import ComparePopperCard from "./components/ComparePopperCard.vue";
import SettingPopperCard from "./components/SettingPopperCard.vue";
import { confirmBox } from "@/utils/messageBox.js";
import { ElMessage } from "element-plus";

const emits = defineEmits([
  "delete",
  "open",
  "export",
  "update",
  "loading",
  "refresh",
]);
const props = defineProps({
  comparisonItems: {
    type: Array,
    default: () => [],
  },
  id: {
    type: String,
    default: "",
  },
});
const comparisonItemsList = ref([]);
const comparisonUid = ref("");
watch(
  () => props.comparisonItems,
  (newVal, oldVal) => {
    comparisonItemsList.value = newVal;
  },
  { immediate: true, deep: true }
);
watch(
  () => props.id,
  (newVal, oldVal) => {
    comparisonUid.value = newVal;
  },
  { immediate: true, deep: true }
);

//打开比较项卡片
const comparePopperCardRef = ref(null);
const comparePopperVisible = ref(false);
const handleToggleComparisonPopper = () => {
  comparePopperVisible.value = !comparePopperVisible.value;
  if (!comparePopperVisible.value) {
    comparePopperCardRef.value.closeCard();
  }
};
const handleCloseComparisonPopper = () => {
  comparePopperVisible.value = false;
};
//打开表格设置卡片
const settingPopperCardRef = ref(null);
const settingPopperCardVisible = ref(false);
const handleToggleSettingPopper = () => {
  settingPopperCardVisible.value = !settingPopperCardVisible.value;
  if (!settingPopperCardVisible.value) {
    settingPopperCardRef.value.closeCard();
  }
};
const handleCloseSettingPopper = () => {
  settingPopperCardVisible.value = false;
};
//添加文献弹框
const dialogSelectLiteratureRef = ref(null);
const handleOpenSelectLiteratureDLG = () => {
  dialogSelectLiteratureRef.value.openDLG("ADD", {
    uid: comparisonUid.value,
    type: "COMPARE",
  });
};
//删除
const handleClickRemove = () => {
  emits("delete");
};
//更新
const handleUpdateLsit = (params) => {
  emits("update", params);
};
const handleUpdateLoadingStatus = (value) => {
  emits("loading", value);
};
//添加
const handleAddLiterature = async (idSelectList) => {
  if (idSelectList.length == 0) {
    ElMessage.warning("请选择要添加的文献");
    return;
  }
  // confirmBox(`确认添加${idSelectList.length}篇文献吗？`).then(async () => {
  // emits("add", idSelectList);
  let params = {
    comparisonUid: comparisonUid.value,
    literatureUids: idSelectList,
  };
  let res = await httpPost(
    "/comparison/v1/addComparisonByLiteratureUid",
    params
  );
  if (res.code == 0) {
    ElMessage.success("添加成功");
    dialogSelectLiteratureRef.value.closeDLG();
    emits("refresh", idSelectList);
  }
  // });
};

//关闭所有弹窗
const closeAllPopovers = () => {
  handleCloseSettingPopper();
  handleCloseComparisonPopper();
};
defineExpose({ closeAllPopovers });
</script>

<style lang="scss" scoped>
.comparison-action-bar {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  .table-bar-left {
    display: flex;
    align-items: center;
    height: 40px;
    margin-left: 15px;
    .option-tab {
      padding: 8px;
      cursor: pointer;
      margin: 0 5px;
    }
    .add-literature {
    }
    .remove-literature {
      .iconfont {
        font-size: 14px;
      }
    }
    .option-tab:hover {
      border-radius: 3px;
      background-color: rgba(209, 209, 209, 0.2);
    }
  }
  .table-bar-right {
    display: flex;
    align-items: center;
    margin-right: 20px;
    .option-icon {
      cursor: pointer;
      width: 26px;
      height: 26px;
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
      .iconfont {
        font-size: 20px;
      }
    }
    .option-icon:hover {
      background-color: rgba(209, 209, 209, 0.2);
    }
  }
}
</style>
